<button [disabled]="valid" (click)="onClick()" class="btn btn-light me-2 float-end" type="button">
    <i class="bi bi-save me-1" [class]="theme.myIconColor"></i> <span> Submit </span>
</button>